<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-body tab2-card">
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <label>Este migrare initiala?</label>
            </div>
            <div class="col-xl-6 col-md-6">
              <label class="d-block">
                <input class="radio_animated" type="radio" [checked]="!!isInit" disabled>
                DA
              </label>
              <label class="d-block">
                <input class="radio_animated" type="radio" [checked]="!isInit" disabled>
                NU
              </label>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <label>Este generat de WebPOSF?</label>
            </div>
            <div class="col-xl-6 col-md-6">
              <label class="d-block">
                <input class="radio_animated" type="radio" [checked]="!!isFromPosf" disabled>
                DA
              </label>
              <label class="d-block">
                <input class="radio_animated" type="radio" [checked]="!isFromPosf" disabled>
                NU
              </label>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <label>Este procesat cu succes?</label>
            </div>
            <div class="col-xl-6 col-md-6">
              <label class="d-block">
                <input class="radio_animated" type="radio" [checked]="!!isSuccess" disabled>
                DA
              </label>
              <label class="d-block">
                <input class="radio_animated" type="radio" [checked]="!isSuccess" disabled>
                NU
              </label>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-xl-2 col-md-2">
              <label>Rezultat</label>
            </div>
            <div class="col-xl-6 col-md-6">
              <input class="form-control" type="text" [ngModel]="resultMessage" disabled/>
            </div>
          </div>
          <div class="form-group row">
            <button class="accordion btn">JSON</button>
            <div class="panel">
              <ngx-json-viewer [json]="messageJson"></ngx-json-viewer>
            </div>
          </div>
          <br>
          <div class="form-group row mt-3 mb-0 pull-right">
            <div class="col-xl-auto col-md-auto">
              <button type="button" class="btn btn-light button-margin" (click)="back()">Renunta</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
